// make header with some comman links
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../assets/images/Simplora-logo.svg";

const Header = () => {

	const [isOpen, setIsOpen] = useState(false);

	const toggleMenu = () => {
		setIsOpen(!isOpen);
	};

	// const googleTranslateElementInit = () => {
	// 	new window.google.translate.TranslateElement(
	// 		{
	// 			pageLanguage: "en",
	// 			autoDisplay: false,
	// 		},
	// 		"google_translate_element"
	// 	);

	// 	// Language mapping for short codes
	// 	const languageMap = {
	// 		English: "En",
	// 		Hindi: "Hi",
	// 		Spanish: "Es",
	// 		French: "Fr",
	// 		German: "De",
	// 		"Chinese (Simplified)": "Zh",
	// 	};

	// 	// Wait for the dropdown to render, then modify it
	// 	setTimeout(() => {
	// 		const select = document.querySelector(".goog-te-combo");
	// 		if (select) {
	// 			Array.from(select.options).forEach((option) => {
	// 				if (languageMap[option.text]) {
	// 					option.text = languageMap[option.text];
	// 				}
	// 			});
	// 		}
	// 	}, 1000); // Delay to ensure the dropdown is rendered
	// };

	// useEffect(() => {
	// 	const addScript = document.createElement("script");
	// 	addScript.setAttribute(
	// 		"src",
	// 		"//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
	// 	);
	// 	document.body.appendChild(addScript);
	// 	window.googleTranslateElementInit = googleTranslateElementInit;
	// }, []);


	return (
		<header className="header">
			<div className="container navbar-container">
				<div className="header-content">
					<div className="logo">
						<Link to="/" className="">
							{/* <img src={Logo} alt="symplora logo" /> */}
							<img src={Logo} alt="symplora logo" />
						</Link>
					</div>
					<nav className="nav-bar">
						<ul>
							<li>
								<NavLink to="/features" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>Features</NavLink>
							</li>
							<li>
								<NavLink to="/pricing" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>Pricing</NavLink>
							</li>
							<li>
								<NavLink to="/aboutus" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>About Us</NavLink>
							</li>
							<li>
								<NavLink to="/resources" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>Resources</NavLink>
							</li>
							<li>
								<NavLink to="/blog" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>Blog</NavLink>
							</li>
						</ul>
					</nav>
				</div>
				<div className="auth-button">
					{/* <div id="google_translate_element"></div> */}
					<button className="btn btn--regular btn--primary">
						Get Demo
					</button>
					<div className={`hamburger ${isOpen ? "open" : ""}`} onClick={toggleMenu}>
						<span></span>
						<span></span>
						<span></span>
					</div>
					<ul className={`nav-links ${isOpen ? "show" : ""}`}>
						<li><a href="/home" className="text-subheading">Home</a></li>
						<li><a href="/features" className="text-subheading">Features</a></li>
						<li><a href="/pricing" className="text-subheading">Pricing</a></li>
						<li><a href="/about" className="text-subheading">About Us</a></li>
						<li><a href="/contact" className="text-subheading">Contact</a></li>
					</ul>
				</div>
			</div>
		</header>
	);
};

export default Header;
